import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import axios from "axios";
import Swal from "sweetalert2";
import { useAuth } from "../AuthProvider";
import { axiosConfig } from "../axiosAPI";
import Month from "../Charts/Month";
import Option from "../Charts/Option";
import DriverCard from "../components/DriverCard";

const LATEST_DRIVERS_URL =
  `${process.env.REACT_APP_BASE_URL}/dashboard/latest-drivers`;

function Dashboard() {
  const [post, setPost] = useState({
    requestCount: "",
    totalPayments: "",
    userCount: "",
  });
  const [drivers, setDrivers] = useState([]);
  const [driversLoading, setDriversLoading] = useState(true);
  const auth = useAuth();

  const getDrivers = async () => {
    setDriversLoading(true);

    try {
      const response = await axiosConfig.get(LATEST_DRIVERS_URL, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      });
      setDrivers(response.data.data ?? []);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    } finally {
      setDriversLoading(false);
    }
  };

  useEffect(() => {
    getDrivers();
  }, []);

  useEffect(() => {
  axios
    .get(`${process.env.REACT_APP_BASE_URL}/dashboard/summary`, {
      headers: {
        Authorization: "Bearer " + auth.token,
        "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
      },
    })
    .then((response) => {
      setPost(response.data.data);
    });
}, []);

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="charts-card">
            <div className="row">
              <div className="col-md-4">
                <div className="card-details">
                  <h2>
                    Number of requests <span>{post?.requestCount}</span>
                  </h2>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card-details">
                  <h2>
                    Number of Users <span>{post?.userCount}</span>
                  </h2>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card-details">
                  <h2>
                    Total Payment <span>{post?.totalPayments}</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="card-details">
                  <Option />
                </div>
              </div>
              <div className="col-lg-8">
                <div className="card-details">
                <Month />
                </div>
              </div>
              <div className="col-md-12">
                <div className="card-details">
                  <div className="row">
                    <div className="col-md-12">
                      <h3>Drivers last week</h3>
                    </div>
                    <div className="col-md-12">
                      {driversLoading ? (
                        <div className="dashboard-drivers-loading">
                          <i
                            className="pi pi-spin pi-spinner"
                            aria-hidden="true"
                          ></i>
                          <span>Loading drivers...</span>
                        </div>
                      ) : drivers.length === 0 ? (
                        <p className="passenger-details-empty mb-0">
                          No drivers registered in the last week.
                        </p>
                      ) : (
                        <div className="dashboard-drivers-grid">
                          {drivers.map((x) => (
                            <DriverCard key={x.uuid} driver={x} returnTo="/Dashboard" />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
